var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoConv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3236 11.4419H21.8124C15.3107 11.4419 10.04 16.7303 10.04 23.2541V43.9892C10.04 50.513 15.3107 55.7985 21.8124 55.7985H25.0056C26.7161 55.7985 28.3556 56.4813 29.563 57.6958L33.8125 61.96C35.5381 63.6882 38.3346 63.6882 40.0598 61.96L44.3066 57.6958C45.5169 56.4813 47.1563 55.7985 48.867 55.7985H52.0601C58.562 55.7985 63.8326 50.513 63.8326 43.9892V34.0271",
    stroke: "#A8A8A8",
    strokeWidth: 4.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0309 10.0043C61.7624 10.0043 64.787 13.039 64.787 16.7834C64.787 20.5248 61.7624 23.5595 58.0309 23.5595C54.299 23.5595 51.2744 20.5248 51.2744 16.7834C51.2744 13.039 54.299 10.0043 58.0309 10.0043Z",
    stroke: "#A8A8A8",
    strokeWidth: 4.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3135 29.6384V38.3953M45.5525 29.6384V38.3953",
    stroke: "#A8A8A8",
    strokeWidth: 4.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConv);
export default __webpack_public_path__ + "static/media/no-conv.ef4a8a9ee5351fa2a4cee115273d7865.svg";
export { ForwardRef as ReactComponent };